export default "__VITE_PUBLIC_ASSET__2c36910d__"